
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">Thông tin người cư trú</h3>
      </div>
      <div class="box-body">
        <div class="row pull-right">
          <div class="col-md-12">
            <button
              class="btn btn-info btn-sm extra-tools pull-right"
              @click="onOpenAddRelativeInput"
            >
              <i class="glyphicon glyphicon-plus"></i>
              Add
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive no-padding">
            <b-table :items="relatives_items" :fields="relatives_fields" class="mt-3" outlined>
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template slot="actions" slot-scope="row">
                <div class="btn-group">
                  <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px;height: 80px;">
                    <li><button
                      class="btn btn-primary btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenEditRelativeInput(row)"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button></li>
                      <li><button
                      class="btn btn-danger btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenDeleteRelative(row)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button></li>
                  </ul>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="box-footer">
      </div>
    </div>
    <!-- Modal Relative Input -->
    <div class="modal fade" :ref="`modal-customer-relative-input`">
      <div class="modal-dialog modal-lg">
        <RelativesInputView
          :id="relative_data.id"
          @relative-add="onAddRelative"
          @relative-save="onSaveRelative"
        />
      </div>
    </div>
    <!-- Modal Confirm Delete -->
    <div class="modal fade" :ref="`modal-customer-relative-delete`">
      <div class="modal-dialog">
        <Confirm
          :id="relative_data.id"
          @confirm="onDeleteRelative"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import RelativesInputView from './RelativesInputView'
import Confirm from "@/components/Confirm.vue"
import utils from '@/lib/utils'

export default {
  name: "RelativesView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      relative_data: {
        id: 0
      },
      relatives_fields: [
        { key: 'nonumber', label: 'common.nonumber', sortable: true, class: 'text-center' },
        { key: 'full_name', label: 'customer.relatives.full_name', sortable: true, class: 'text-center' },
        { key: 'relationship', label: 'customer.relatives.relationship', sortable: true, class: 'text-center' },
        { key: 'yob', label: 'customer.relatives.yob', sortable: true, class: 'text-center' },
        { key: 'gender', label: 'customer.relatives.gender', sortable: true, class: 'text-center' },
        { key: 'nationality', label: 'customer.relatives.nationality', sortable: true, class: 'text-center' },
        { key: 'phone_number', label: 'customer.relatives.phone_number', sortable: true, class: 'text-center' },
        { key: 'notes', label: 'customer.relatives.notes', sortable: true, class: 'text-center' },
        { key: "actions", label: "common.action", sortable: true }
      ],
      relatives_items: [],
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.getRelativesList()
      } else {
        // pass
      }
    },
    RELATIVES_LIST: function() {
      let relatives_items = []
      let nonumber = 0
      this.RELATIVES_LIST.forEach( (relative, i) => {
        if (relative.resident_type != 1) {return}
        nonumber += 1
        let id = relative.id
        let full_name = relative.full_name
        let relationship = this.getRelationshipName(relative.relationship)
        let yob = relative.yob
        let gender = this.getGender(relative.gender)
        let nationality = relative.nationality_details.name
        let phone_number = relative.phone_number
        let notes = relative.notes
        let item = {
          id: id,
          nonumber: nonumber,
          full_name: full_name,
          relationship: relationship,
          yob: yob,
          gender: gender,
          nationality: nationality,
          phone_number: phone_number,
          notes: notes
        }
        relatives_items.push(item)
      })
      this.relatives_items = relatives_items
      this.$emit('relatives_items', this.relatives_items)
    }
  },
  computed: {
    ...mapGetters([
      "RELATIVES_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "GET_RELATIVE_LIST",
      "ADD_RELATIVE",
      "UPDATE_RELATIVE",
      "DELETE_RELATIVE",
      "GET_CARDS_LIST"
    ]),
    getGender: function (gender) {
      if(gender==1){
        return this.$t(`customer.gender_type[0]`)
      }
      if(gender==2){
        return this.$t(`customer.gender_type[1]`)
      }
      if(gender==3){
        return this.$t(`customer.gender_type[2]`)
      }
    },
    getRelationshipName: function(status_id) {
      return utils.getRelationshipName(status_id)
    },
    getCardsList: function(data){
      if (this.id == 0){ return }
      const payload = {
        params: {
          user: this.id
        }
      }
      this.GET_CARDS_LIST(payload)
    },
    onToggleModalInput: function(action="show") {
      $(this.$refs[`modal-customer-relative-input`]).modal(action)
    },
    onToggleDeleteConfirm: function(action="show") {
      $(this.$refs[`modal-customer-relative-delete`]).modal(action)
    },
    getRelativesList: function(data){
      const payload = {
        params: {
          user: this.id
        }
      }
      this.GET_RELATIVE_LIST(payload)
    },
    onAddRelative: function(saveRelative) {
      saveRelative.user = this.id
      const payload = {
        data: saveRelative
      }
      this.ADD_RELATIVE(payload).then(
        function(res) {
          this.onToggleModalInput("hide")
          this.getRelativesList()
          this.getCardsList()
        }.bind(this)
      )
    },
    onSaveRelative: function(id, saveRelative) {
      saveRelative.user = this.id
      const payload = {
        id: id,
        data: saveRelative
      }
      this.UPDATE_RELATIVE(payload).then(
        function(res) {
          this.onToggleModalInput("hide")
          this.getRelativesList()
          this.getCardsList()
        }.bind(this)
      )
    },
    onOpenAddRelativeInput: function() {
      this.relative_data.id = 0
      this.onToggleModalInput()
    },
    onOpenEditRelativeInput: function(row) {
      this.relative_data.id = row.item.id
      this.onToggleModalInput()
    },
    onOpenDeleteRelative: function(row) {
      this.relative_data.id = row.item.id
      this.onToggleDeleteConfirm()
    },
    onDeleteRelative: function(id) {
      const payload = {
        id: id
      }
      this.DELETE_RELATIVE(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide")
          this.getRelativesList()
          this.getCardsList()
        }.bind(this)
      )
    },
  },
  mounted() {
    this.getRelativesList()
  },
  components: {
    RelativesInputView,
    Confirm
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Customer/RelativesView.vue